import AuthLayout from "./AuthLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import OTPInput from "react-otp-input";
import { useEffect, useState } from "react";
import { showError, showToast } from "../../constants/toasts";
import { temporaryToken } from "../../reducers/authSlice";
import { useAppDispatch } from "../../hooks/store";
import {
  usePostForgotPasswordMutation,
  usePostVerifyOtpMutation,
} from "../../service/auth";
import Loader from "../../constants/Loader";

const OtpVerification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useAppDispatch();
  const [optVerificationMutation] = usePostVerifyOtpMutation();
  const [ForgotPasswordMutation] = usePostForgotPasswordMutation();

  const [otp, setOtp] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [countDown, setCountDown] = useState<number>(59);
  const [error, setError] = useState<boolean>(false);

  const handleSubmit = async () => {
    if (otp?.length != 4) {
      showError("Please enter OTP");
      return;
    }
    if (otp?.length === 4) {
      setError(false);

      const body = {
        email: state?.email,
        otp: otp,
      };
      setLoading(true);
      try {
        const response = await optVerificationMutation(body).unwrap();
        if (response?.status === 200) {
          setLoading(false);
          dispatch(temporaryToken({ tempToken: response?.data?.token }));
          showToast("OTP verified successfully");
          navigate("/reset-password", {
            replace: true,
            state: { email: state?.email },
          });
        } else {
          setLoading(false);
          setOtp("");
        }
      } catch (error: any) {
        setLoading(false);
        setOtp("");
        if (error?.data?.message) {
          showError(error?.data?.message || "");
        }
      }
    } else {
      setError(true);
    }
  };

  const handleResendOtp = async (e: any) => {
    e.preventDefault();
    const body = {
      email: state?.email,
    };

    try {
      setLoading(true);
      const response = await ForgotPasswordMutation(body).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        showToast("OTP Resent Successfully");
        setCountDown(59);
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (countDown > 0) {
      setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    } else {
      setCountDown(0);
    }
  }, [countDown]);

  return (
    <AuthLayout>
      <Loader isLoad={loading} />
      <div className="authBox">
        <h2>OTP Verification</h2>
        <p>Please enter otp send to your email address</p>
        <form>
          <div className="control_group">
            <div className="opt_fields">
              <label>Enter OTP</label>
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} />}
                inputType="tel"
              />
            </div>
            <div className="auth_bottom">
              <p>
                <span
                  className="link"
                  onClick={(e) => {
                    if (countDown === 0) {
                      handleResendOtp(e);
                    } else {
                      return;
                    }
                  }}
                >
                  Resent OTP
                  {countDown !== 0 ? (
                    <span
                      style={{
                        margin: 0,
                      }}
                    >
                      (00:{countDown < 10 ? `0${countDown}` : countDown})
                    </span>
                  ) : null}
                </span>
              </p>
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <span className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </span>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
